/**
 * Created by Marsh on 2016.5.11.
 */

'use strict';

module.exports = {

  /**
   * 常用的几种颜色值
   */
  Color: {
    // 禁用时颜色值
    MODEL_DISABLE: '#CCCCCC',

    // 黑色颜色值
    MODEL_BLACK: '#000'
  },

  /**
   * 程序项目类型
   */
  AppPlatformType: {
    MOBILE: 'MtMobile',
    PAD: 'MtPad',
    DESKTOP: 'MtDesktop',
    WEB: 'MtWeb',
    BLANK: 'MtBlank',
    CUSTOM: 'MtCustom'
  },

  /**
   * 手机和Pad项目类型中，app屏幕方向
   */
  ScreenOrientation: {
    PORTRAIT: 'MoPortrait',
    LANDSCAPE: 'MoLandscape'
  },

  DashMode: {
    SdSolid: 'solid',
    SdDash: 'dashed',
    SdDot: 'dotted',
    SdDashDot: 'dash-dot',
    SdDashDotDot: 'dash-dot-dot'
  },
  /**
   * 页面链接类型
   */
  PageLinkType: {
    PAGE_LINK: 'ltPageLink',
    INCLUDE_PAGE: 'ltIncludePage'
  },

  /**
   * 页面链接动画
   */
  PageLinkAnimateType: {
    NONE: 'AmNone',
    PUSH_LEFT: 'AmPushLeft',
    PUSH_RIGHT: 'AmPushRight',
    PUSH_UP: 'AmPushUp',
    PUSH_DOWN: 'AmPushDown',
    SLIDE_LEFT: 'AmSlideLeft',
    SLIDE_RIGHT: 'AmSlideRight',
    SLIDE_UP: 'AmSlideUp',
    SLIDE_DOWN: 'AmSlideDown',
    FADE: 'AmFade',
    IRIS: 'AmIris'
  },

  /**
   * 提示框组件Yes和No枚举， 对应：TMockYesAndNo
   */
  AlertYesAndNo: {
    NONE: 'MBNone',
    YES: 'MBYes',
    NO: 'MBNo',
    index: {0: 'NONE', 1: 'YES', 2: 'NO'}
  },

  /**
   * 内部布局方向， 对应：TInternalLayout
   */
  InternalLayout: {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal'
  },

  /**
   * 文字布局方向， 对应：TMockTextDirection
   */
  TextDirection: {
    LEFT: 'tdLeft',
    RIGHT: 'tdRight'
  },

  HorizontalDirection: {
    LEFT: 'HdLeft',
    RIGHT: 'HdRight'
  },

  VerticalDirection: {
    TOP: 'VdTop',
    BOTTOM: 'VdBottom'
  },

  Direction: {
    HORIZONTAL: 'SmHori',
    VERTICAL: 'SmVert'
  },

  ButtonStatus: {
    NORMAL: 'BsNormal',
    SELECTED: 'BsSelected',
    FOCUSED: 'BsFocused'
  },
  /**
   * 组件状态，对应：TMockComStatus
   */
  ComStatus: {
    ENABLE: 'MfEnabled',
    SELECTED: 'MfSelected',
    DISABLED: 'MfDisabled',
    SELECTED_AND_DISABLED: 'MfSelectedAndDisabled',
    isSelected: function (state) {
      return state === this.SELECTED || state === this.SELECTED_AND_DISABLED;
    },
    isDisabled: function (state) {
      return state === this.DISABLED || state === this.SELECTED_AND_DISABLED;
    }
  },

  /**
   * 组件状态，对应TMockComStatus1
   */
  ComStatus1: {
    ENABLE: 'CsEnabled',
    FOCUS: 'CsInFocus',
    DISABLED: 'CsDisabled'
  },

  /**
   * 组件状态，对应：TMockComStatus2
   */
  ComStatus2: {
    ENABLE: 'MsEnabled',
    DISABLE: 'MsDisabled'
  },

  /**
   * 形状组件类型， 对应：TShapeType
   */
  ShapeType: {
    ELLIPSE: 'SbEllipse',
    RECTANGLE: 'SbRectangle',
    DIAMOND: 'SbDiamond',
    STAR: 'SbStar',
    PARALLELOGRAM: 'SbParallelogram',
    TRIANGLE: 'SbTriangle'
  },

  /**
   * 组件旋转角度类型， 对应：TRotationAngle
   */
  RotationAngle: {
    ZERO: 'TdZero',
    NINETY: 'TdNinety',
    ONE_HUNDRED_EIGHTY: 'TdOneHundredEighty',
    TWO_HUNDRED_SEVENTY: 'TdTwoHundredSeventy'
  },

  /**
   * 交互事件中所支持的交互类型，没有对应枚举类
   */
  StateEventType: {
    MOUSE_OVER: 'state_mouseOver',
    MOUSE_OUT: 'state_mouseOut',
    MOUSE_DOWN: 'state_mouseDown',
    MOUSE_UP: 'state_mouseUp'
  },

  /**
   * 字体居中属性，对应：THoriAlign
   */
  HoriAlign: {
    LEFT: 'HaLeft',
    CENTER: 'HaCenter',
    RIGHT: 'HaRight'
  },

  /**
   * 字体垂直属性，对应： TVertAlign
   */
  VertAlign: {
    TOP: 'VaTop',
    MIDDLE: 'VaMiddle',
    BOTTOM: 'VaBottom'
  },

  /**
   * 图片滤镜属性，对应： TImageFilter
   */
  ImageFilter: {
    NONE: 'MfNone',
    PENCIL: 'MfPencil',
    SKETCH: 'MfSketch',
    MONO: 'MfMono'
  },

  ImageFitMode: {
    //fmFit, fmFill, fmStretch, fmTile, fmCenter
    Fit: 0,
    Fill: 1,
    STRETCH: 2,
    TILE: 3,
    CENTER: 4
  },
  /**
   * 弹出面板定位策略
   */
  PositionPolicy: {
    FREE: 'ppFree',
    SCREEN: 'ppScreenFix',
    SOURCE_COM: 'ppSourceCom'
  },

  /**
   * 弹出面板相对于屏幕定位的方式
   */
  PositionScreenMode: {
    TOP: 'psTop',
    CENTER: 'psCenter',
    BOTTOM: 'psBottom'
  },

  /**
   * 弹出面板相对于源组件的定位方式
   */
  PositionComMode: {
    TOP: 'pcTop',
    BOTTOM: 'pcBottom',
    LEFT: 'pcLeft',
    RIGHT: 'pcRight',
    //后面几种临时扩充的。目前PC端还没有
    TOP_LEFT: 'pcTopLeft',
    TOP_RIGHT: 'pcTopRight',
    BOTTOM_LEFT: 'pcBottomLeft',
    BOTTOM_RIGHT: 'pcBottomRight'
  },

  PopupPanelClosePolicy: {
    NONE: 'cmNone',
    ALL: 'cmClickAllArea',
    OUT_AREA: 'cmClickOutSizeArea'
  },

  /*移动项目中弹出面板弹出动画*/
  PopupPanelAniType_Mobile: {
    NONE: 'aniNone',
    FADE: 'aniFade',
    ZOOM_IN: 'aniZoomIn',
    MOVE_UP: 'aniMoveUp',
    MOVE_DOWN: 'aniMoveDown',
    MOVE_LEFT: 'aniMoveLeft',
    MOVE_RIGHT: 'aniMoveRight',
    EXPAND_DOWN: 'aniExpandDown',
    EXPAND_RIGHT: 'aniExpandRight',
    EXPAND_LEFT: 'aniExpandLeft',
    EXPAND_UP: 'aniExpandUp'
  },

  /*弹出面板弹出动画*/
  PopupPanelAniType: {
    NONE: 'dnNone',
    FADE: 'dnFade',
    ZOOM_IN: 'dnZoomIn'
  },

  /**
   * 切换面板切换动画类型
   */
  StackPanelAniType: {
    NONE: 'spaNone',
    PUSH: 'spaPush',
    SLIDE: 'spaSlide',
    FADE: 'spaFade'
  },

  CarouselIndicatorType: {
    RECTANGLE: 'SiRectangle',
    CIRCLE: 'SiCircle',
    NUMBER: 'SiNumber'
  },
  CarouselIndicatorDirection: {
    TOP: 'sidTop',
    LEFT: 'sidLeft',
    BOTTOM: 'sidBottom',
    RIGHT: 'sidRight'
  },

  /**
   * 图片轮播中图片的填充方式
   */
  ImageCarouselFitMode: {
    AUTO: 'fmAutoFit',
    STRETCH: 'fmStretchFit'
  },

  PhoneType: {
    ALLWHITE: 'PtAllWhite',
    TOPONLY: 'PtTopOnly',
    TOPANDBOTTOM: 'PtTopAndBottom',
    ALLBLACK: 'PtAllBlack'
  },

  /**
   * 进度条组件样式，对应：TMockProgressStyle
   */
  ProgressBarStyle: {
    BAR: 'MfBar',
    STRIPE: 'MfStripe'
  },

  /**
   * 提示角度方向， 对应：TAroundDirection
   */
  ToolTipDirection: {
    LEFT_TOP: 'AdLeftTop',
    TOP: 'AdTop',
    RIGHT_TOP: 'AdRightTop',
    RIGHT: 'AdRight',
    RIGHT_BOTTOM: 'AdRightBottom',
    BOTTOM: 'AdBottom',
    LEFT_BOTTOM: 'AdLeftBottom',
    LEFT: 'AdLeft'
  },

  /**
   * 垂直花括号方向
   */
  VCurlyDirection: {
    LEFT: 'DrLeft',
    RIGHT: 'DrRight'
  },

  /**
   * 水平花括号方向
   */
  HCurlyDirection: {
    TOP: 'DrTop',
    BOTTOM: 'DrBottom'
  },

  /**
   * 图标按钮风格，
   */
  IconButtonStyle: {
    CIRCLE: 'ISCircle',
    RECTANGLE: 'ISRectangle',
    ROUND_RECTANGLE: 'ISRoundRectangle'
  },

  /**
   * 图标按钮方向
   */
  IconLabelDirection: {
    TEXT_BOTTOM: 'MiTextBottom',
    TEXT_LEFT: 'MiTextLeft',
    TEXT_RIGHT: 'MiTextRight'
  },

  /**
   * 用户行为发生后，需要响应的交互类型
   */
  ActionResponseType: {
    LINK: 'page-link',
    INTERACTIVE: 'interactive-link',
    OUTER: 'url-link',
    STATE: 'state-link',
    NONE: 'none'
  },

  CUSTOM_EVENT: {
    ON_RESIZE: 'onResize',
    ON_PAINT: 'onPaint',
    ON_PROPS_CHANGE: 'onPropsChange'
  },

  TAB_BAR_STYLE : {
    SQUARE : 'csSquare',
    LEAN : 'csLean'
  }
};


// WEBPACK FOOTER //
// ./src/types/appTypes.js